import AssetMetrics from './AssetMetrics.container';

export default AssetMetrics;
